import { ReactElement, ReactNode } from 'react';

import TabsOrganize from './TabsOrganize';

export interface TabT {
  label: string;
  name: string;
  content: ReactNode;
  icon?: string | ReactElement;
  iconPosition?: 'bottom' | 'top' | 'end' | 'start';
  disabled?: boolean;
}

export default TabsOrganize;
